export default __webpack_public_path__ + "static/media/detailsDay.3485eeff.png";